import { SVGProps } from 'react'

export const AmericanExpress = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="50"
      height="19"
      viewBox="0 0 50 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.72656 18.7761V10.7461H18.0553L18.9489 11.9353L19.872 10.7461H50.1032V18.2223C50.1032 18.2223 49.3126 18.768 48.3983 18.7761H31.6586L30.6511 17.5103V18.7761H27.3497V16.6153C27.3497 16.6153 26.8987 16.9169 25.9237 16.9169H24.8V18.7761H19.8014L18.9091 17.5614L18.003 18.7761H9.72656Z"
        fill="#016FD0"
      />
      <path
        d="M0 4.69449L1.87816 0.224609H5.12625L6.19213 2.72845V0.224609H10.2298L10.8643 2.03431L11.4795 0.224609H29.6044V1.13441C29.6044 1.13441 30.5572 0.224609 32.1231 0.224609L38.004 0.24559L39.0515 2.71666V0.224609H42.4304L43.3604 1.64404V0.224609H46.7703V8.25457H43.3604L42.4691 6.83054V8.25457H37.5047L37.0055 6.98876H35.6709L35.1798 8.25457H31.8131C30.4657 8.25457 29.6044 7.36335 29.6044 7.36335V8.25457H24.5283L23.5208 6.98876V8.25457H4.64506L4.14617 6.98876H2.81582L2.32045 8.25457H0V4.69449Z"
        fill="#016FD0"
      />
      <path
        d="M2.54104 1.21484L0.0078125 7.22813H1.65708L2.12449 6.02399H4.84178L5.30677 7.22813H6.99236L4.46155 1.21484H2.54104ZM3.47829 2.61431L4.30655 4.71848H2.6476L3.47829 2.61431Z"
        fill="white"
      />
      <path
        d="M7.16797 7.22617V1.21289L9.51166 1.22178L10.8748 5.09876L12.2054 1.21289H14.5303V7.22617H13.0578V2.79533L11.497 7.22617H10.2056L8.64044 2.79533V7.22617H7.16797Z"
        fill="white"
      />
      <path
        d="M15.5371 7.22623V1.21289H20.3421V2.55798H17.0251V3.58657H20.2646V4.85254H17.0251V5.9207H20.3421V7.22623H15.5371Z"
        fill="white"
      />
      <path
        d="M21.1934 1.21484V7.22818H22.6658V5.09186H23.2858L25.0514 7.22818H26.8508L24.9133 5.01274C25.7085 4.94424 26.5287 4.24747 26.5287 3.16572C26.5287 1.9003 25.5559 1.21484 24.4701 1.21484H21.1934ZM22.6658 2.55993H24.349C24.7528 2.55993 25.0465 2.88239 25.0465 3.19291C25.0465 3.59241 24.666 3.8259 24.3708 3.8259H22.6658V2.55993Z"
        fill="white"
      />
      <path d="M28.6363 7.22623H27.1328V1.21289H28.6363V7.22623Z" fill="white" />
      <path
        d="M32.2016 7.22623H31.8771C30.3069 7.22623 29.3535 5.96324 29.3535 4.24429C29.3535 2.48287 30.2962 1.21289 32.2791 1.21289H33.9066V2.6371H32.2196C31.4147 2.6371 30.8454 3.27845 30.8454 4.25912C30.8454 5.42368 31.4963 5.91279 32.4341 5.91279H32.8216L32.2016 7.22623Z"
        fill="white"
      />
      <path
        d="M35.4063 1.21484L32.873 7.22813H34.5223L34.9897 6.02399H37.707L38.172 7.22813H39.8576L37.3268 1.21484H35.4063ZM36.3435 2.61431L37.1718 4.71848H35.5128L36.3435 2.61431Z"
        fill="white"
      />
      <path
        d="M40.0293 7.22623V1.21289H41.9014L44.2918 4.99101V1.21289H45.7642V7.22623H43.9527L41.5018 3.34921V7.22623H40.0293Z"
        fill="white"
      />
      <path
        d="M10.7344 17.7497V11.7363H15.5393V13.0814H12.2224V14.11H15.4618V15.376H12.2224V16.4441H15.5393V17.7497H10.7344Z"
        fill="white"
      />
      <path
        d="M34.2773 17.7497V11.7363H39.0823V13.0814H35.7653V14.11H38.9893V15.376H35.7653V16.4441H39.0823V17.7497H34.2773Z"
        fill="white"
      />
      <path
        d="M15.7256 17.7496L18.0651 14.7801L15.6699 11.7363H17.525L18.9515 13.6179L20.3828 11.7363H22.1653L19.8016 14.743L22.1453 17.7496H20.2905L18.9055 15.8977L17.5541 17.7496H15.7256Z"
        fill="white"
      />
      <path
        d="M22.3184 11.7363V17.7497H23.8296V15.8507H25.3796C26.6911 15.8507 27.6852 15.1404 27.6852 13.7589C27.6852 12.6145 26.9055 11.7363 25.5709 11.7363H22.3184ZM23.8296 13.0963H25.4619C25.8856 13.0963 26.1885 13.3614 26.1885 13.7886C26.1885 14.1899 25.8871 14.4809 25.4571 14.4809H23.8296V13.0963Z"
        fill="white"
      />
      <path
        d="M28.3242 11.7363V17.7497H29.7967V15.6133H30.4167L32.1822 17.7497H33.9817L32.0442 15.5342C32.8393 15.4657 33.6595 14.769 33.6595 13.6872C33.6595 12.4218 32.6867 11.7363 31.601 11.7363H28.3242ZM29.7967 13.0814H31.4799C31.8837 13.0814 32.1774 13.4039 32.1774 13.7144C32.1774 14.1139 31.7968 14.3474 31.5017 14.3474H29.7967V13.0814Z"
        fill="white"
      />
      <path
        d="M39.7651 17.7497V16.4441H42.712C43.148 16.4441 43.3368 16.2036 43.3368 15.9397C43.3368 15.6869 43.1486 15.4314 42.712 15.4314H41.3803C40.2228 15.4314 39.5781 14.7113 39.5781 13.6303C39.5781 12.6661 40.1685 11.7363 41.8886 11.7363H44.756L44.136 13.0893H41.6561C41.182 13.0893 41.0361 13.3433 41.0361 13.5858C41.0361 13.8351 41.2164 14.11 41.5786 14.11H42.9736C44.2639 14.11 44.8239 14.8573 44.8239 15.8359C44.8239 16.888 44.1999 17.7497 42.9033 17.7497H39.7651Z"
        fill="white"
      />
      <path
        d="M45.1674 17.7497V16.4441H48.1143C48.5504 16.4441 48.7392 16.2036 48.7392 15.9397C48.7392 15.6869 48.551 15.4314 48.1143 15.4314H46.7827C45.6251 15.4314 44.9805 14.7113 44.9805 13.6303C44.9805 12.6661 45.5708 11.7363 47.2909 11.7363H50.0998L49.5384 13.0893H47.0584C46.5844 13.0893 46.4384 13.3433 46.4384 13.5858C46.4384 13.8351 46.6188 14.11 46.9809 14.11H48.3759C49.6663 14.11 50.2262 14.8573 50.2262 15.8359C50.2262 16.888 49.6023 17.7497 48.3057 17.7497H45.1674Z"
        fill="white"
      />
    </svg>
  )
}
